export enum EmailTemplateType {
    Header,
    Footer,
    WelcomeMessage
}

export class EmailTemplate {
    constructor(public type: EmailTemplateType, public template: string) {}
}
